import * as React from "react";
import Modal from "../..//ui/modal/Modal";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import FormButtonsView from "../../ui/form/FormButtonsView";
import SectionView from "../../layout/section/SectionView";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
}

type Props = ComponentProps;

export default class ConfirmRemoveOrderModal extends React.PureComponent<Props> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Are you sure?"} autoWidth={true}>
				<div style={{width: "500px"}}>
					<SectionView>
						All changes made to Bill of Materials will be reset to its original items.
					</SectionView>
					<FormButtonsView align={"right"}>
						<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
						<ButtonPrimary label={"Reset"} onClick={this.props.onConfirm}/>
					</FormButtonsView>
				</div>
			</Modal>
		)
	}
}